<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">master_user</div>
      <div :class="'container ' + pageContainerSize">
        <search-control
        v-if="localShowSearch == true"
        style="padding-bottom: 10px;"
        :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
        <ag-grid-vue :style="localTabStyle" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_master_user';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

import fileDownloadModal from '@/components/modals/file-download-modal';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"master_user",
      page_acl: acl.master_user,
      execute_filter_on_back:true,
      limit_user_ids:[],
      state_last_filter_options:"last_filter_options",
      state_is_editing_new:"is_editing_new",
      state_current_row:"current_row",
    };
  },
  computed: {
    limitUserIds:{
      get(){
        return this.limit_user_ids;
      },
      set(v){
        this.limit_user_ids = v;
      }
    },
    localShowSearch(){
      if(this.$props.showSearch  == true){
        return true;
      }else{
        return false;
      }
    },
    localAllUserIds(){
      if(this.$props.allUserIds  == true){
        return true;
      }else{
        return false;
      }
    },
    localTabStyle(){
      if(typeof this.$props.tabStyle == "undefined" || this.$props.tabStyle  == ''){
        return "width: 100%; height: 400px";
      }else{
        return this.$props.tabStyle
      }
    },
    localShowDetailsButtons(){
      if(this.$props.showDetailsButtons == true){
        return true;
      }else{
        return false;
      }
    },
    localShowCheckBox(){
      if(this.$props.showCheckBox == true){
        return true;
      }else{
        return false;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        // utils.extend(fields.approval_status, {}),
        utils.extend(fields.user_id, {}),
        utils.extend(fields.user_shimei, {}),
        utils.extend(fields.role, {}),
        utils.extend(fields.company, {}),
        utils.extend(fields.department, {}),
        utils.extend(fields.team, {}),
      ];
    }
  },
  methods: {
    onDetailsClick(ev, data) {
      this.$emit("onDetailsClick",data.seq_id)
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:this.localShowDetailsButtons,show_checkbox:this.localShowCheckBox})
    },
    onRowSelected(ev){
        this.$emit("selected",[ev.node.data.seq_id])
        this.clearSelectionsDatasource()
    },
    onArraySelected(ev){
        this.$emit("selected",this.selectedRowArr.map(m=>{return m.seq_id;}))
    },
    on_emails_loaded(err,rows){
      var emails = "";
      rows.forEach(f=>{
        if(emails.length > 0){
          emails += ","
        }
        if(f.mail_address){
          emails += f.mail_address.trim()
        }
      })
      this.$emit("email_list_updated",emails)
    }
  },
  mounted() {
    this.limitUserIds = {
      mode:this.$props.subSearchMode || "only",
      list:this.$props.searchData
    }
    this.emulateSearchControlChangedDatasource();
    this.gridOptions.api.sizeColumnsToFit();
    if(this.$props.refreshTag && this.$props.refreshTag.length > 0){
      bus.$on(this.$props.refreshTag,(data)=>{

        this.limitUserIds = {
          mode:this.$props.subSearchMode || "only",
          list:data
        }
        this.emulateSearchControlChangedDatasource();
        this.gridOptions.api.sizeColumnsToFit();
      })
    }
  },
  beforeDestroy() {
    if(this.$props.refreshTag && this.$props.refreshTag.length > 0){
      bus.$off(this.$props.refreshTag)
    }
  },
  beforeMount() {

    if(this.$props.sourceState == "2" || this.$props.sourceState == 2){
      this.state_last_filter_options = "last_filter_options2";
      this.state_is_editing_new = "is_editing_new2";
      this.state_current_row = "current_row2";
    }

    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.api_request_options = {only_with_email:true, sub_search:"limitUserIds"};
    if(this.localAllUserIds == false){
      this.initDatasource({load_only_with_filter:true,loaded_cb:this.on_emails_loaded});
    }else{
      this.initDatasource({loaded_cb:this.on_emails_loaded});
    }
  },
  props: [
    "searchData",
    "showSearch",
    "showDetailsButtons",
    "showCheckBox",
    "tabStyle",
    "allUserIds",
    "sourceState",
    "refreshTag",
    "subSearchMode"
  ]
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// master_user.vue?52322ecc